import React, { useEffect, useState } from "react";
import axiosInstance from '../../../axiosInstance';
import FormBuilderComponent from "./form_builder";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "apollo-react/components/Modal";
import { Formik, Form, Field } from "formik";
import SwitchInput from "../../common/Form/switchInput";
import TextInput from "../../common/Form/textInput";
import Grid from "apollo-react/components/Grid";
import SelectInput from "../../common/Form/selectInput";

const CreateForms = ({persona}) => {
  const [t] = useTranslation();
  const [form, setForm] = useState({ form_id: 0, name: "", description: "" });
  const [forms, setforms] = useState([{ id: 0, name: "" }]);
  const [subFormsTemplate, setSubFormsTemplate] = useState([]);
  const [discardModal, setDiscardModal] = useState(false);

  let navigate = useNavigate();

  const getSubFormsTemplate = () => {
    axiosInstance
      .get("/api/subforms-template")
      .then((resp) => {
        // console.log(resp);

        setSubFormsTemplate(resp.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getSubFormsTemplate();
    //console.log(forms);
  }, []);

  const [formDataFields, setFormDataFields] = useState({
    isTemplate: false,
    formFields: [],
  });
  const formData = [
    // {
    //   type: "header",
    //   subtype: "h1",
    //   label: "formBuilder",
    // },
    // {
    //   type: "paragraph",
    //   label: "This is a demonstration of formBuilder running.",
    // },
  ];

  const handleFormSave = async (formJsonData) => {
    try {
      //TODO to be required in the form
      if (form.name === "") {
        toast.error(t("Subform Name is required"), { position: "top-center" });
        return;
      }

      if (formJsonData.length === 2) {
        toast.error(t("Subform must contain at least one field"), {
          position: "top-center",
        });
        return;
      }
      
      const updatedForm = { ...form };
      // console.log("-------------", {...basicFormData});

      const url = form.template ? "api/subforms-template" : "api/subforms";

      await axiosInstance.post(`${process.env.REACT_APP_SERVER_URL}/${url}`,
        {
          ...updatedForm,
          require_approval: 0,
          json_object: formJsonData,
          approved: 0,
          version: 0.1,
          // workflowId: 1,
        },
        { withCredentials: true })
        .catch((err) => console.log(err));

      toast.success(t("Form Created Successfully!"), {
        position: "top-center",
      });
      navigate(-1);
    } catch (error) {
      console.error(t("Error saving form"), ":", error);
    }
  };

  const handleFormChange = (name, value) => {
    if (name === "sub_form_id") {
      const selectedForm = subFormsTemplate.find(
        (form) => form.id === Number(value)
      );
      setForm({
        ...selectedForm,
        [name]: value,
        name: form.name,
        form_id: "",
        description: "",
      });

      if (selectedForm && selectedForm["json_object"])
        setFormDataFields({
          formFields: JSON.parse(selectedForm["json_object"]),
          isTemplate: true,
        });
      else setFormDataFields({ ...formDataFields, formFields: [] });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const renderBasicFormInfo = () => {
    const basicFormInfo = (
      <div>
        <Field name="name">
          {({ field, meta }) => (
            <TextInput
              {...field}
              meta={meta}
              label={"Subform name"}
              value={form?.[`name`] || ""}
              onChange={(value) => handleFormChange("name", value)}
              required
              // fullWidth={false}
            />
          )}
        </Field>

        <Field name="description">
          {({ field, meta }) => (
            <TextInput
              {...field}
              meta={meta}
              label={"Subform Description"}
              value={form?.[`description`]}
              onChange={(value) => handleFormChange("description", value)}
              multiline={true}
              textareaWidth={"100%"}
            />
          )}
        </Field>
      </div>
    );
    return basicFormInfo;
  };

  return (
    <div
      className="content"
      style={{
        border: "solid 1px #E9E9E9",
        padding: "24px",
        borderRadius: "5px",
      }}
    >
      <Grid item md={12}>
        <Formik
          initialValues={form}
          enableReinitialize={true}
          onSubmit={handleFormSave}
        >
          <Form>
            {renderBasicFormInfo()}

            <Field name="sub_form_id">
              {({ field, meta }) => (
                <SelectInput
                  {...field}
                  meta={meta}
                  label={"Clone predefined Subforms"}
                  options={subFormsTemplate?.map((form) => ({
                    key: form.id,
                    value: form.id,
                    label: `${form.name}`,
                  }))}
                  onChange={(e, value) => {
                    handleFormChange("sub_form_id", e);
                  }}
                  value={form.sub_form_id}
                />
              )}
            </Field>

            <Field name="template">
              {({ field, meta }) => (
                <SwitchInput
                  {...field}
                  meta={meta}
                  label={t("Save as Template")}
                  checked={form.template === 1}
                  value={form?.template}
                  onChange={(checked) => {
                    handleFormChange("template", checked);
                  }}
                  style={{ marginTop: "16px", marginBottom: "8px" }}
                />
              )}
            </Field>
          </Form>
        </Formik>
      </Grid>
      <FormBuilderComponent
        formData={formDataFields.formFields}
        onFormSave={handleFormSave}
        isTemplate={formDataFields.isTemplate}
        handleDiscardModal={() => setDiscardModal(!discardModal)}
      />

      <Modal
        open={discardModal}
        message="Are you sure you want to discard your changes?"
        buttonProps={[
          {
            onClick: () => {
              setDiscardModal(false);
            },
          },
          {
            label: "Confirm",
            onClick: () => {
              setForm({ form_id: 0, name: "", description: "" });
              setDiscardModal(false);
              setFormDataFields({ ...formDataFields, formFields: [] });
            },
          },
        ]}
        hideHeader
        id="hideHeader"
      />
    </div>
  );
};

export default CreateForms;
